// shared icon definitions
import _TakeActionIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import _MaterialToReadIcon from 'material-ui/svg-icons/action/bookmark';
import _VideoIcon from 'material-ui/svg-icons/notification/ondemand-video';
import _BlogIcon from 'material-ui/svg-icons/hardware/laptop';

export const TakeActionIcon = _TakeActionIcon;
export const MaterialToReadIcon = _MaterialToReadIcon;
export const VideoIcon = _VideoIcon;
export const BlogIcon = _BlogIcon;



/** WEBPACK FOOTER **
 ** ./src/components/common/Icons.js
 **/